import { render } from "./SimpleTable.vue?vue&type=template&id=03aa3130&ts=true"
import script from "./SimpleTable.vue?vue&type=script&lang=ts"
export * from "./SimpleTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__